import { Background, style } from '@do/walrus';
import React, { ReactElement } from 'react';
import { LoginVariantProps } from '../../../interfaces/loginVariant';
import defaultBg from '../../../assets/backgrounds/HeroBackground-Option1-01.png';
import { Column, Row } from '../../Common';
import { Splash } from './Splash';
import { ButtonStyles } from '../../RegistrationTemplateProvider';

interface Props {
  variant: LoginVariantProps;
  buttonStyles: ButtonStyles;
}

export const Variant: React.FC<Props> = ({ children, variant, buttonStyles }): ReactElement => {
  return variant?.splash ? (
    <Row>
      <Column
        style={{
          background: style.colors.grey.lightest,
        }}
      >
        {children}
      </Column>
      <Splash buttonStyles={buttonStyles} splash={variant.splash} variantType={variant.type} />
    </Row>
  ) : (
    <>
      <Background url={variant.background?.url || defaultBg} />
      {children}
    </>
  );
};
